import ClientDetails from "../../common/ClientDetails";
import {
  calculateAge,
  formatCalendarDate,
  formatCalendarDateForInput,
} from "../../../Utils/helper";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";

import "./ClientsOnCasePanel.css";
import "../../common/CasePanelHeader.css";

const ClientRow = ({ item, onRowClick }) => {
  const birthday = formatCalendarDate(item.clientData?.birthday);
  const hasBirthday = Boolean(formatCalendarDateForInput(item.clientData?.birthday));
  const age = hasBirthday ? calculateAge(item.clientData.birthday) : "";
  const hasAge = Number.isInteger(age);

  return (
    <tr
      className={`info-color-panels-odd-even ${onRowClick ? "clients-on-case-clickable-row" : ""}`}
      onClick={onRowClick ? () => onRowClick(item) : undefined}
    >
      <td>
        {onRowClick ? (
          <button
            type="button"
            className="clients-on-case-client-button"
            onClick={(event) => {
              event.stopPropagation();
              onRowClick(item);
            }}
          >
            <ClientDetails client={item.clientData} showBirthday={false} />
          </button>
        ) : (
          <ClientDetails client={item.clientData} showBirthday={false} />
        )}
      </td>
      <td className="clients-on-case-birthday-icon" aria-hidden="true">
        {hasBirthday && (
          <img
            style={{
              minWidth: "15px",
            }}
            src={birthdayIcon}
            width="15"
            height="15"
            alt=""
          />
        )}
      </td>
      <td aria-label={hasBirthday ? `Birthday: ${birthday}` : undefined}>
        {hasBirthday ? birthday : ""}
      </td>
      <td className="text-primary-25">{hasAge ? "age" : ""}</td>
      <td>{hasAge ? age : ""}</td>
      <td className="clients-on-case-spacing" aria-hidden="true" />
      <td className="clients-on-case-status text-primary-25">-</td>
      <td className="clients-on-case-spacing" aria-hidden="true" />
      <td className="clients-on-case-status text-primary-25">-</td>
      <td className="clients-on-case-spacing" aria-hidden="true" />
      <td className="clients-on-case-status text-primary-25">-</td>
      <td aria-hidden="true" />
    </tr>
  );
};

const ClientsOnCasePanel = ({ data = [], onAddClient, onRowClick }) => (
  <div className="background-div case-home-responsive-panel clients-on-case-panel">
    <div className="clients-on-case-scroll">
      <table className="clients-on-case-table" aria-label="Clients on Case">
        <colgroup>
          <col className="clients-on-case-content-column" span={5} />
          <col />
          <col className="clients-on-case-content-column" />
          <col />
          <col className="clients-on-case-content-column" />
          <col />
          <col className="clients-on-case-content-column" />
          <col className="clients-on-case-action-column" />
        </colgroup>
        <thead>
          <tr onClick={onAddClient} className="case-panel-action-header">
            <th colSpan={5} scope="colgroup" className="clients-on-case-heading">
              Clients on Case
            </th>
            <th className="clients-on-case-spacing" aria-hidden="true" />
            <th scope="col">Lead</th>
            <th className="clients-on-case-spacing" aria-hidden="true" />
            <th scope="col">Disposition</th>
            <th className="clients-on-case-spacing" aria-hidden="true" />
            <th scope="col">Settled</th>
            <th className="p-0">
              <button
                type="button"
                className="menu-bar-style case-panel-action-header clients-on-case-add-button"

                aria-label="New Client on Case"
              >
                <span className="case-panel-header-icon case-panel-add-icon" aria-hidden="true" />
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <ClientRow key={item.id} item={item} onRowClick={onRowClick} />
          ))}
          {Array.from({ length: Math.max(0, 6 - data.length) }, (_, index) => (
            <tr key={`empty-${index}`} className="info-color-panels-odd-even" aria-hidden="true">
              <td colSpan={12} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default ClientsOnCasePanel;
